import type {
  NetworkContributionDetail,
  NetworkContributionDetailSelectionParams,
} from '@gozoki/api-types'
import { keepPreviousData, type UseQueryResult, useQuery } from '@tanstack/react-query'
import { fetchNetworkContributionDetail } from '../queries/networkContributionDetail.queries'

export const useNetworkContributionDetail = (
  selection: NetworkContributionDetailSelectionParams,
  enabled = true,
): UseQueryResult<NetworkContributionDetail, unknown> =>
  useQuery({
    queryKey: [
      'get-network-contribution-detail',
      selection.storeIds,
      selection.storeAgeFilter,
      selection.ageStoreIds,
      selection.startDate,
      selection.endDate,
      selection.comparableStartDate,
      selection.comparableEndDate,
    ],
    queryFn: () => fetchNetworkContributionDetail(selection),
    placeholderData: keepPreviousData,
    enabled,
  })
